var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","show-all-levels":_vm.showAllLevels,"placeholder":_vm.placeholder || '选择部门',"options":_vm.organizationOptions,"size":"mini","props":{
    label: 'organizationName',
    value: 'organizationId',
    children: 'children',
    multiple: true,
    ..._vm.props,
  },"collapse-tags":_vm.collapseTags,"value":_vm.organization},on:{"input":organization => _vm.$emit('input', organization),"change":organization => _vm.$emit('change', organization)}})
}
var staticRenderFns = []

export { render, staticRenderFns }